import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy: Writing and editing → Polish the draft. Started from the lesson
 * page in a new tab; never auto-started.
 */
const tour: TutorialDefinition = {
  id: "polish-the-draft",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Polish the draft",
  description: "Enhance Writing, writing suggestions, and Find and Replace.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "polish-the-draft",
  autoStart: false,
  steps: [
    {
      target: sel("caseListItem"),
      title: "Open a report",
      content: "Click a report that has a draft to polish.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("caseListItem"), event: "click" },
      hint: "Open a report to continue",
      spotlightClicks: true,
    },
    {
      target: sel("editorNarrative"),
      waitFor: sel("editorNarrative"),
      waitTimeoutMs: 10000,
      title: "Enhance Writing",
      content:
        "Select a rough sentence or paragraph and click Enhance Writing in the floating menu. Compare Original and Enhanced, then Accept Changes or Discard.",
      disableBeacon: true,
      placement: "right",
    },
    {
      target: sel("editorProofread"),
      waitFor: sel("editorProofread"),
      title: "Writing suggestions",
      content:
        "Turn it on here. After you edit a paragraph and pause, underlines appear. Click one to accept the replacement, dismiss it, or Add to dictionary.",
      disableBeacon: true,
      placement: "bottom",
    },
    {
      target: sel("editorFind"),
      waitFor: sel("editorFind"),
      title: "Find and Replace",
      content:
        "Open it, type the text to find, then use the replace button to add a replacement field. Replace changes one match, Replace All changes every match. Before you export, search for [ to find leftover placeholders.",
      disableBeacon: true,
      placement: "bottom",
    },
  ],
};

export default tour;
